import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="E-Commerce App" link="https://www.github.com/Blackwatch1910/Ecommerce" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
This is an E-Commerce frontend React App with dummy API calls. State management handled using Redux. Dealt with all complex concepts of React-redux.
    </ProjectCard>
    <ProjectCard title="Blog Application" link="https://www.github.com/Blackwatch1910/blog-application" bg="linear-gradient(to right, #cc2b5e 0%, #753a88 100%)" mdxType="ProjectCard">
A blog application in which you can perform various activities like, Add, Edit and Delete Blogs. It is developed in Angular.
    </ProjectCard>                                                                                 
    <ProjectCard title="CRUD App" link="https://www.github.com/Blackwatch1910/CRUD-App" bg="linear-gradient(to right, #eecda3 0%, #ef629f 100%)" mdxType="ProjectCard">
A basic Create, Read, Update and Delete node.js Application. Mongoose, mongodb and express.js were used as utility frameworks and databases.
    </ProjectCard>
    <ProjectCard title="Image Search" link="https://www.github.com/Blackwatch1910/Pics" bg="linear-gradient(to right, #43cea2 0%, #185a9d 100%)" mdxType="ProjectCard">
A React App that searches images given as text and renders the images onto the client's window.
    </ProjectCard>
    <ProjectCard title="Fitbit" link="https://www.github.com/Blackwatch1910/Fitbit" bg="linear-gradient(to right, #4568dc 0%, #b06ab3 100%)" mdxType="ProjectCard">
A basic fitbit band that displays current time and heart rate (frontend only). Also, we can change band colors using multiple color options.
    </ProjectCard>
    <ProjectCard title="TODO-App" link="https://www.github.com/Blackwatch1910/TODO-App" bg="linear-gradient(to right, #ffd89b 0%, #19547b 100%)" mdxType="ProjectCard">
A basic Todo list application using javascript.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      